import React, { PureComponent } from "react";
import styled from "styled-components";
import SelectorArrowIcon from "containers/assets/icon-dropdown-arrow-filled.svg";
import SelectorArrowIconDard from "containers/assets/icon-arrow-select-solid.svg";

const SelectorContainer = styled.div`
  position: relative;
`;

const SelectedOptionWrapper = styled.div`
  border: 2px solid #5C91F5;
  border-radius: 4px;
  width: 180px;
  padding: 6px 40px 6px 16px;
  color: #5C91F5;
  cursor: pointer;
  font-family: 'Mukta Vaani';
  font-size: 16px;
  line-height: 16px;
  height: 32px;
  display: flex;
  align-items: center;
  background: #fff;

  ${p => (p.size && p.size === 'small') && `{
    padding: 2px 28.5px 2px 12px;
    width: auto;
    height: auto;
    line-height: 20px;
    font-size: 14px;
    border: 1px solid #D5D9DD;
    color: rgba(0,27,59,0.94);
  }`}}
`;

const SelectorArrow = styled.div`
  width: 32px;
  height: 32px;
  background-color: #5C91F5;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  ${p => (p.size && p.size === 'small') && `{
    background-color: transparent;
    width: 28.5px;
    height: auto;
    display: flex;
    align-items: center;

    img {
      width: 7px;
      height: auto;
      margin-left: 6.5px;
      content: url(${SelectorArrowIconDard});
    }
  }`}}
`;

const SelectorItemsWrapper = styled.div`
  z-index: 1;
  position: absolute;
  display: none;
  left: 0;
  right: 0;
  width: 100%;

  ${p =>
    p.isShown &&
    `
    display: block;
  `}
`;

const SelectorItems = styled.ul`
  width: 100%;
  border: 3px solid #ffffff;
  border-radius: 5px;
  list-style: none;
  font-weight: 800;
  color: #ffffff;
  background-color: #2a4169;
  padding: 0;
  max-height: 300px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 3px;
  }
   
  &::-webkit-scrollbar-thumb {
    background: #5C91F5; 
  }

  li {
    cursor: pointer;
    padding: 6px 16px;
  }

  li:hover {
    color: #2a4169;
    background: #fff;
  }

  ${p => (p.size && p.size === 'small') && `{
    background-color: #fff;
    color: rgba(0, 27, 59, 0.94);
    font-weight: 500;
    border: 1px solid #D5D9DD;

    li {
      padding: 2px 16px;
    }

    li:hover {
      background: #FAFBFD;
    }
  }`}}
`;

class Selector extends PureComponent {
  constructor(props) {
    super(props);

    this.currentRef = null;
    this.currentRef2 = null;

    this.state = {
      menuShown: false
    };
  }

  componentDidMount() {
    if (window) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (window) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  handleClickOutside = e => {
    let clicked1 = false;
    if (this.currentRef && this.currentRef.contains(e.target)) {
      clicked1 = true;
    }

    let clicked2 = false;
    if (this.currentRef2 && this.currentRef2.contains(e.target)) {
      clicked2 = true;
    }

    if (!clicked1 && !clicked2) {
      this.setState({
        menuShown: false
      });
    }
  };

  toggleMenu = () => {
    this.setState({
      menuShown: !this.state.menuShown
    });
  };

  render() {
    const { menuShown } = this.state;
    const {
      options,
      onSelectorChange,
      selectedOptionId,
      size
    } = this.props;

    return (
      <SelectorContainer>
        <SelectedOptionWrapper
          innerRef={node => (this.currentRef = node)}
          onClick={this.toggleMenu}
          size={size}
        >
          <span>{selectedOptionId ? options.find(i => i.id === selectedOptionId).name : options[0].name}</span>
          <SelectorArrow size={size}>
            <img src={SelectorArrowIcon} alt="arrow" />
          </SelectorArrow>
        </SelectedOptionWrapper>
        <SelectorItemsWrapper
          innerRef={node => (this.currentRef2 = node)}
          isShown={menuShown}
        >
          <SelectorItems size={size}>
            {options.map((option, index) => {
              return (
                <li
                  onClick={() => {
                    onSelectorChange(option.id);
                    this.toggleMenu();
                  }}
                  value={option.id}
                  key={index}
                >
                  {option.name}
                </li>
              );
            })}
          </SelectorItems>
        </SelectorItemsWrapper>
      </SelectorContainer>
    );
  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/selector.js